import { Phone, Mail, MapPin, Linkedin, Facebook, Youtube, ExternalLink } from "lucide-react";
import { Separator } from "@/components/ui/separator";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_aa20eee5-f3ca-4771-aefa-339a7569da1e/artifacts/qkx859ux_RESQ%20logo%20kolor%4010x.png";

const uslugiLinks = [
  { label: "Serwis", href: "#uslugi" },
  { label: "Zaplecze logistyczno-magazynowe", href: "#uslugi" },
  { label: "Quantidose", href: "#uslugi" },
  { label: "iReQuest", href: "#uslugi" },
  { label: "Wsparcie IT", href: "#uslugi" },
  { label: "Współpraca OEM", href: "#uslugi" },
];

const grupaQLinks = [
  { label: "ResQmed", href: "https://resqmed.pl" },
  { label: "IQmed", href: "https://iqmed.pl" },
  { label: "GrupaQ", href: "https://grupaq.pl" },
];

const prawneLinks = [
  { label: "Polityka prywatności", href: "/rodo" },
  { label: "GDPR / RODO – NIS 2", href: "/rodo" },
];

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer
      className="bg-[#212738] dark:bg-[#0A0B0D] pt-16 pb-8"
      aria-label="Stopka"
      data-testid="footer"
    >
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-8 lg:gap-12">
          {/* Company Info */}
          <div className="col-span-2 lg:col-span-2">
            <a href="#" className="inline-block">
              <img
                src={LOGO_URL}
                alt="ResQ Logo"
                className="h-10 w-auto"
              />
            </a>
            <p className="mt-4 text-white/60 text-sm leading-relaxed max-w-xs">
              Profesjonalny serwis urządzeń medycznych. Część GrupaQ — innowacyjne rozwiązania dla sektora ochrony zdrowia.
            </p>
            <p className="mt-4 text-[#EA8628] font-semibold">
              Dbamy o Życie
            </p>

            <div className="mt-6 space-y-3">
              <a
                href="tel:+48123110312"
                className="flex items-center gap-2 text-white/60 hover:text-[#EA8628] transition-colors duration-200 text-sm"
              >
                <Phone className="w-4 h-4" />
                +48 123 110 312
              </a>
              <a
                href="mailto:biuro@ckkresq.pl"
                className="flex items-center gap-2 text-white/60 hover:text-[#EA8628] transition-colors duration-200 text-sm"
              >
                <Mail className="w-4 h-4" />
                biuro@ckkresq.pl
              </a>
              <div className="flex items-start gap-2 text-white/60 text-sm">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <span>ul. Gospodarska 22, 05-822 Milanówek</span>
              </div>
              <div className="flex items-start gap-2 text-white/60 text-sm">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <span>ul. Jana Pawła II 38/1, 32-540 Trzebinia</span>
              </div>
              <div className="flex items-start gap-2 text-white/60 text-sm">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <span>ul. Stanisława Moniuszki 15/45, 31-523 Kraków</span>
              </div>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-semibold mb-4">Oferta</h3>
            <ul className="space-y-2">
              {uslugiLinks.map((link, idx) => (
                <li key={idx}>
                  <a
                    href={link.href}
                    className="text-white/60 hover:text-[#EA8628] transition-colors duration-200 text-sm"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* GrupaQ */}
          <div>
            <h3 className="text-white font-semibold mb-4">GrupaQ</h3>
            <ul className="space-y-2">
              {grupaQLinks.map((link, idx) => (
                <li key={idx}>
                  <a
                    href={link.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-1 text-white/60 hover:text-[#EA8628] transition-colors duration-200 text-sm"
                  >
                    {link.label}
                    <ExternalLink className="w-3 h-3" />
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-white font-semibold mb-4">Informacje prawne</h3>
            <ul className="space-y-2">
              {prawneLinks.map((link, idx) => (
                <li key={idx}>
                  <a
                    href={link.href}
                    className="text-white/60 hover:text-[#EA8628] transition-colors duration-200 text-sm"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>

            {/* Social Links */}
            <div className="mt-6 flex gap-3">
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-lg bg-white/5 flex items-center justify-center text-white/60 hover:text-[#EA8628] hover:bg-white/10 transition-colors duration-200"
                aria-label="LinkedIn"
              >
                <Linkedin className="w-5 h-5" />
              </a>
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-lg bg-white/5 flex items-center justify-center text-white/60 hover:text-[#EA8628] hover:bg-white/10 transition-colors duration-200"
                aria-label="Facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                href="https://www.youtube.com/@CKKResQ"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-lg bg-white/5 flex items-center justify-center text-white/60 hover:text-[#EA8628] hover:bg-white/10 transition-colors duration-200"
                aria-label="YouTube"
                data-testid="footer-youtube-link"
              >
                <Youtube className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>

        <Separator className="my-8 bg-white/10" />

        <div className="flex flex-col sm:flex-row justify-between items-center gap-4 text-sm text-white/40">
          <p>
            &copy; {currentYear} CKK ResQ. Wszelkie prawa zastrzeżone.
          </p>
          <p>
            Część grupy{" "}
            <a
              href="https://grupaq.pl"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#EA8628] hover:text-[#ff9734] transition-colors duration-200"
            >
              GrupaQ
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};
